import { IFileUploadError } from 'features/claims/types'
import { FaTimesCircle } from 'react-icons/fa'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'

interface IProps {
  fileError?: IFileUploadError
  startOver: () => void
}

export const AllClaimFailedMessage = ({ fileError, startOver }: IProps) => {
  console.log('fileError', fileError?.missingColumns)
  const missingColumns = fileError?.missingColumns ? fileError.missingColumns.join(', ') : ''
  return (
    <ErrorContainer>
      <FaTimesCircle className="times-circle-icon" />
      <h3>{missingColumns ? 'Issues were found with columns in your file' : 'Something’s not quite right.'}</h3>
      <p>
        {missingColumns ? (
          <>
            Please ensure the following columns are present and named correctly: <br />
            <br /> {missingColumns}{' '}
          </>
        ) : (
          <>{fileError?.detail ? fileError.detail : 'There was a problem validating your claim file.'}</>
        )}
      </p>

      <div className="footer-start-over">
        <Button
          data-testid="file-upload-btn"
          variant="info-outline"
          radius="rounded"
          className=" btn-start-over"
          size="small"
          color="info"
          onClick={() => startOver()}
        >
          Start Over
        </Button>
      </div>
    </ErrorContainer>
  )
}

const ErrorContainer = styled.div`
  text-align: center;
  margin-top: 3.75rem;
  .times-circle-icon {
    width: 2.5438rem;
    height: 2.5438rem;
    color: ${({ theme }) => theme.colors.error.neutral};
  }
  h3 {
    margin-top: 1.25rem;
    font-size: 1.125rem;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: ${({ theme }) => theme.colors.neutral.neutral};
  }
  p {
    font-size: 1rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: ${({ theme }) => theme.colors.grey.dark};
  }
  .footer-start-over {
    margin-top: 6.25rem !important;
    margin: 2rem;
    button {
      width: 100%;
      height: 3rem;
      font-size: 1.125rem;
    }
  }
`
